/**
 * It's a generated file, preferable to extend this in external file
 */
import {
   DESTINATION_FILENAME_ERROR_LONG,
   isDestinationFilenameValid,
} from 'common/validation/isDestinationFilenameValid';
import * as yup from 'common/yup';
import {CONTEXT_SEND_PARAMETER} from 'common/yup/constants';
import {enums} from 'types/enums';

export const DiplomatFileDescriptorNames = {
   pattern: 'sourceFilename',
   _patternType: '_patternType',
   recursive: 'recursive',
   matchType: 'matchType',
   matchCase: 'matchCase',
   useRegex: 'useRegex',
} as const;

export const DiplomatFileDescriptorCore = yup.object({
   sourceFilename: yup.string(),
   // .when([DiplomatFileDescriptorNames.useRegex, DiplomatFileDescriptorNames._patternType], {
   //    is: (useRegex, _patternType) => {
   //       if (_patternType) {
   //          return _patternType === enums.patternType.enum.REGEX;
   //       }
   //       return useRegex;
   //    },
   //    then: yup.string().test('regex', i18n.t('Should be a valid regexp'), (val: string) => {
   //       let res = false;
   //       try {
   //          new RegExp(val);
   //          res = true;
   //       } catch (e) {}
   //       return res;
   //    }),
   // }),
   destinationFilename: yup
      .string()
      .ensure()
      .test('valid filename', DESTINATION_FILENAME_ERROR_LONG, isDestinationFilenameValid),
   required: yup.boolean(),
   numberFiles: yup.number().integer().moreThan(-1).default(0),
   ignoreFileHandling: yup.boolean(),
   useModifyDate: yup.boolean(),
   [DiplomatFileDescriptorNames.useRegex]: yup.bool(),
   [DiplomatFileDescriptorNames.recursive]: yup.bool(),
   [DiplomatFileDescriptorNames.matchCase]: yup.bool().default(false),
   [DiplomatFileDescriptorNames.matchType]: yup
      .string()
      .oneOf(enums.matchType.keys)
      .default(enums.matchType.enum.INCLUDE),
});
export type IDiplomatFileDescriptor = yup.InferType<typeof DiplomatFileDescriptorCore>;

export const DiplomatFileDescriptorWithHelpFields = DiplomatFileDescriptorCore.shape({
   [DiplomatFileDescriptorNames._patternType]: yup.string().oneOf(enums.patternType.keys),
}).transform(function (val, origin) {
   if (!val._patternType) {
      val._patternType = val.useRegex
         ? enums.patternType.enum.REGEX
         : enums.patternType.enum.STRING;
   }
   return val;
});
export type IDiplomatFileDescriptorWithHelpFields = yup.InferType<
   typeof DiplomatFileDescriptorWithHelpFields
>;

const DiplomatFileDescriptorToSend = DiplomatFileDescriptorCore.clone().transform(function (
   val,
   origin
) {
   if (val._patternType) {
      val.useRegex = val._patternType === enums.patternType.enum.REGEX;
      delete val._patternType;
   }
   return val;
});

export const DiplomatFileDescriptor = DiplomatFileDescriptorCore.when(CONTEXT_SEND_PARAMETER, {
   is: true,
   then: DiplomatFileDescriptorToSend,
   otherwise: DiplomatFileDescriptorWithHelpFields,
}) as typeof DiplomatFileDescriptorWithHelpFields;
